import mixins from '@synergycms_core/less/mixins.js';
export default {
    test: {},
    row: {},
    isSelected: {},
    isFocused: {},
    countries: {},
    selectBox: {
        position: 'relative',
        display: 'inline-block',
        verticalAlign: 'top',
        marginRight: '7px',
        height: '40px',
        width: '90px',
        ...mixins.boxShadow('0 0 2px 0 rgba(0, 0, 0, 0.5)'),
        '& $row': {
            padding: '0'
        },
        '& $test': {
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            padding: '0 6px 0 23px',
            '& > span': {
                fontSize: '13px'
            },
            '&:lang(ar)':{
                paddingLeft:'6px',
                paddingRight:'23px'
            }
        },
        '& $isSelected': {
            backgroundColor: '#2684ff',
            color: 'white'
        },
        '& $isFocused': {
            backgroundColor: '#deebff',
            color: 'black'
        },
        '& $countries': {
            '@media (min-width: 901px)': {
                height: '50px'
            }
        },
        '@media (min-width: 901px)': {
            height: '50px'
        },
        '&:lang(ar)':{
            marginRight:'0',
            marginLeft:'7px',
            '@media (min-width:910px)': {
                marginRight: '7px',
                marginLeft: '0',
            }
        }
    }
}